import { faArrowRightFromBracket, faCalendarDays, faChalkboardUser, faCheckToSlot, faCreditCard, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect } from "react";
import { Button, Container, Image, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import $ from "jquery";

const FrontOfficeNavbar = () => {
    const { t } = useTranslation();
    const { setShowLogoutModal, setLoading, changeView } = useContext(BasicContext);

    const navbarPos = [
        { icon: faCalendarDays, name: t("schedule.schedule"), action: () => changeView({ nav: "schedule", params: { moduleName: "APP" } }) },
        {
            icon: faChalkboardUser,
            name: (
                <>
                    <span className="d-lg-none">{t(`classes.classes`)}</span>
                    <span className="d-none d-lg-inline d-xxl-none">
                        {t(`classes.classesLG`)}{" "}
                        <span className="d-none d-xl-inline">
                            <br />
                        </span>
                        {t(`classes.classesLG2`)}
                    </span>
                    <span className="d-none d-xxl-inline">{t("classes.classesXL")}</span>
                </>
            ),
            action: () => changeView({ nav: "classesAndPasses" }),
        },
        {
            icon: faCreditCard,
            name: (
                <>
                    <span className="d-lg-none">{t(`passes.passes`)}</span>
                    <span className="d-none d-lg-inline">{t("littleShop")}</span>
                </>
            ),
            action: () => changeView({ nav: "passes", sub: "passesList" }),
        },
    ];

    const menuPos = [
        { icon: faUser, name: t("profile"), action: () => changeView({ nav: "userProfile" }) },
        { icon: faMoneyCheckDollar, name: t("payments.paymentsList"), action: () => changeView({ nav: "paymentsList" }) },
        {
            icon: faCheckToSlot,
            name: t("reservations.reservationsList"),
            action: () => changeView({ nav: "reservations", sub: "reservationsList", params: { moduleName: "APP" } }),
        },
        { icon: faArrowRightFromBracket, name: t("logout"), action: () => setShowLogoutModal(true) },
    ];

    const handleCloseNav = () => {
        if ($(".navbar-collapse").hasClass("show")) {
            const toggleButton = document.querySelector(".navbar-toggler");
            if (toggleButton) {
                toggleButton.click(); // Wywołuje kliknięcie w Navbar.Toggle
            }
        }
    };

    useEffect(() => {
        setLoading(false);
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Navbar expand="xl" sticky="top" id="frontOfficeNavbar" className="office-navbar">
                <Container>
                    <Navbar.Brand>
                        <Image src="/images/pt_logo.svg" alt="pole therapy logo" className="logo-navbar" />
                    </Navbar.Brand>
                    {navbarPos.map((e, i) => (
                        <Nav.Link
                            key={i}
                            className="me-lg-2 me-xl-3"
                            as={Button}
                            onClick={() => {
                                e.action();
                                handleCloseNav();
                            }}
                        >
                            <FontAwesomeIcon icon={e.icon} className="me-lg-2" />
                            <span className="d-none d-lg-inline">{e.name}</span>
                        </Nav.Link>
                    ))}
                    <Navbar.Toggle aria-controls="basicNavBar" />
                    <Navbar.Collapse id="basicNavBar">
                        <Nav className="me-auto"></Nav>
                        <Nav>
                            {menuPos.map((e, i) => (
                                <Fragment key={i}>
                                    {e.icon && (
                                        <Nav.Link
                                            as={Button}
                                            variant="link"
                                            onClick={() => {
                                                e.action();
                                                handleCloseNav();
                                            }}
                                        >
                                            <FontAwesomeIcon icon={e.icon} className="me-2" />
                                            {e.name}
                                        </Nav.Link>
                                    )}
                                </Fragment>
                            ))}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Fragment>
    );
};

export default FrontOfficeNavbar;
